module.exports = __webpack_public_path__ + "img/ct.423b8757.jpg";